<template>
  <div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          供货单位<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item ref="formItem" prop="supplyUnitId">
            <el-select v-model="supplyUnitModel" placeholder="请选择供货单位" value-key="id" style="width:100%;" @change="change">
              <el-option v-for="option in supplyUnit" :key="option.id" :value="option" :label="option.name " />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          供货单位地址：
        </div>
        <div class="rj-baseinfo__item">
          <div style="max-height: 38px;overflow: hidden">
            {{ form.supplyAddress }}
          </div>
        </div>
      </div>
    </div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          供货单位电话：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="supplyPhone">
            <el-input v-model="form.supplyPhone" />
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { mapState, mapActions } from 'vuex';
export default {
  data () {
    return {
      supplyUnitModel: {}
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {
    ...mapState({
      supplyUnit: state => state.enumeration.supplyUnit
    })
  },
  methods: {
    ...mapActions('enumeration', [
      'initSupplyUnit'
    ]),
    initData () {
      if (this.form.supplyUnitId) {
        this.supplyUnitModel = {
          supplyAddress: this.form.supplyAddress,
          supplyPhone: this.form.supplyPhone,
          supplyUnit: this.form.supplyUnit,
          name: this.form.supplyUnit,
          id: this.form.supplyUnitId
        };
      }
    },
    change (val) {
      this.form.supplyAddress = val.supplyAddress;
      this.form.supplyPhone = val.supplyPhone;
      // this.form.supplyUnit = val.name;
      this.$set(this.form, 'supplyUnit', val.name); // 为了验证
      this.form.supplyUnitId = val.id;
      this.$refs.formItem.validate('change');
      this.$emit('changesupply', val);
      this.$emit('handleChange');
    }
  },
  mounted () {
    this.initSupplyUnit();
    this.initData();
  }
};
</script>
